export const INTEGRATIONS = {
  SFTP: 1,
  ZENDESK: 2,
  WEBHOOK: 3,
  API: 4,
  WHATSAPP: 5
};

export const INTEGRATIONS_DATA = {
  [INTEGRATIONS.SFTP]: {
    name: "integration.sftp.name",
    description: "integration.sftp.description",
    link: "/organization/integrations/sftp"
  },
  [INTEGRATIONS.ZENDESK]: {
    name: "integration.zendesk.name",
    description: "integration.zendesk.description",
    survey_description: "integration.zendesk.survey_description",
    link: "/organization/integrations/zendesk"
  },
  [INTEGRATIONS.WEBHOOK]: {
    name: "integration.webhook.name",
    description: "integration.webhook.description",
    link: "/organization/integrations/webhook"
  },
  [INTEGRATIONS.API]: {
    name: "integration.api.name",
    description: "integration.api.description",
    link: "/organization/integrations/api"
  },
  [INTEGRATIONS.WHATSAPP]: {
    name: "integration.whatsapp.name",
    description: "integration.whatsapp.description",
    link: "/organization/integrations/whatsapp"
  }
};

export const WHATSAPP_BROKERS = {
  POSITUS: 1,
  TWILLIO: 2
};

export const SURVEY_INTEGRATIONS = [INTEGRATIONS.ZENDESK];
